
import {
  getBlockResponseFromError,
  isAllowedBlockEntryPoint,
  isBlockSuccess,
} from '@/utils/blockUser'

const DEFAULT_AVATAR = require('@/assets/image/global/default-avatar.png')

export default {
  name: 'BlockUserDialog',
  data() {
    return {
      innerVisible: false,
      isSubmitting: false, // 确认拉黑提交中，防止重复点击
      dialogWidth: '480px',
      nickname: '',
      avatar: '',
      targetUserId: null,
      entryPoint: '',
      pending: null, // Promise 回调，仅 open() 打开时有值
    }
  },
  computed: {
    avatarSrc() {
      return this.avatar || DEFAULT_AVATAR
    },
  },
  mounted() {
    this.updateDialogWidth()
    if (process.client) {
      window.addEventListener('resize', this.updateDialogWidth)
    }
  },
  beforeDestroy() {
    if (process.client) {
      window.removeEventListener('resize', this.updateDialogWidth)
    }
  },
  methods: {
    /**
     * 打开拉黑确认。成功 resolve，取消/关闭 reject('cancel')。
     * @param {{ target_user_id: number|string, entry_point: string, nickname?: string, avatar?: string }} options
     */
    open(options = {}) {
      if (this.pending) {
        this.settle(false)
      }
      this.nickname = options.nickname || ''
      this.avatar = options.avatar || ''
      this.targetUserId = options.target_user_id
      this.entryPoint = options.entry_point
      this.updateDialogWidth()
      this.innerVisible = true
      return new Promise((resolve, reject) => {
        this.pending = { resolve, reject }
      })
    },
    /** 关闭并按是否确认结束 Promise；失败提交不走这里 */
    settle(confirmed) {
      const pending = this.pending
      this.pending = null
      this.innerVisible = false
      if (!pending) return
      if (confirmed) {
        pending.resolve(true)
        return
      }
      pending.reject('cancel')
    },
    /** 弹窗宽度：移动端 90%，桌面固定 480px 对齐设计稿 */
    updateDialogWidth() {
      if (!process.client) return
      this.dialogWidth = document.body.clientWidth <= 768 ? '90%' : '480px'
    },
    onAvatarError(e) {
      e.target.src = DEFAULT_AVATAR
    },
    /** 取消或关闭不改变拉黑状态；未显示时忽略 close */
    handleCancel() {
      if (this.isSubmitting || !this.innerVisible) return
      this.settle(false)
    },
    goBlacklistSettings() {
      this.handleCancel()
      this.$router.push({ path: '/setup/blacklist' })
    },
    /** 提交拉黑。失败保留弹窗，提示只认接口 msg */
    async handleConfirm() {
      if (this.isSubmitting) return
      if (!this.$store.state.isLogin) {
        this.$jumpTerminus(1)
        return
      }
      if (!isAllowedBlockEntryPoint(this.entryPoint) || !this.targetUserId) return

      this.isSubmitting = true
      try {
        const res = await this.$global.userBlock({
          target_user_id: Number(this.targetUserId),
          entry_point: this.entryPoint,
        })
        this.applyBlockResult(res)
      } catch (error) {
        const body = getBlockResponseFromError(error)
        if (body) {
          this.applyBlockResult(body)
        } else {
          this.$message.error(this.$t('page.UNKNOWN_ERROR'))
        }
      } finally {
        this.isSubmitting = false
      }
    },
    /** 成功关弹窗并客户端提示；失败保留弹窗，直接展示接口 msg */
    applyBlockResult(res) {
      if (isBlockSuccess(res)) {
        const name = (this.nickname && String(this.nickname).trim()) || this.$t('page.DELETED_USER')
        this.$message.success(this.$t('page.BLOCK_SUCCESS_TOAST', { nickname: name }))
        this.settle(true)
        return
      }
      const isNotLoggedIn = res && res.code === 400 && !res.msg
      if (isNotLoggedIn) {
        this.$message.warning(this.$t('page.PLEASE_SIGN_IN'))
        this.$jumpTerminus(1)
        return
      }
      this.$message.error((res && res.msg) || this.$t('page.UNKNOWN_ERROR'))
    },
  },
}
